var _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2462_1572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 10,
    width: 92,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.6667 64.5833C91.6667 76.0896 82.3396 85.4167 70.8333 85.4167C67.1042 85.4167 63.6 84.4375 60.5708 82.7188C57.3628 80.9004 54.6942 78.2639 52.8372 75.078C50.9803 71.8922 50.0012 68.2709 50 64.5833C50 59.2333 52.0167 54.3542 55.3292 50.6667C57.281 48.4874 59.671 46.7448 62.3427 45.5529C65.0145 44.361 67.9078 43.7466 70.8333 43.75C82.3396 43.75 91.6667 53.0771 91.6667 64.5833Z",
    fill: "#555555",
    stroke: "white",
    strokeWidth: 8.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8333 25V43.75C67.9078 43.7466 65.0145 44.361 62.3427 45.5529C59.671 46.7448 57.281 48.4874 55.3291 50.6667C51.8913 54.4859 49.9924 59.4447 50 64.5833C50.0012 68.2709 50.9802 71.8922 52.8372 75.078C54.6942 78.2639 57.3627 80.9004 60.5708 82.7188C55.025 84.3958 47.6625 85.4167 39.5833 85.4167C22.325 85.4167 8.33331 80.7521 8.33331 75V25",
    stroke: "white",
    strokeWidth: 8.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8333 24.9997C70.8333 30.7518 56.8416 35.4163 39.5833 35.4163C22.325 35.4163 8.33331 30.7518 8.33331 24.9997C8.33331 19.2476 22.325 14.583 39.5833 14.583C56.8416 14.583 70.8333 19.2476 70.8333 24.9997Z",
    fill: "#555555",
    stroke: "white",
    strokeWidth: 8.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 58.3327C8.33331 64.0848 22.325 68.7493 39.5833 68.7493C43.3479 68.7493 46.9583 68.5285 50.3 68.1202M8.33331 41.666C8.33331 47.4181 22.325 52.0827 39.5833 52.0827C45.325 52.0827 50.7062 51.566 55.3291 50.666M80.2083 60.416L68.75 71.8743L62.5 65.6243",
    stroke: "white",
    strokeWidth: 8.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2462_1572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H100V100H0V0Z",
    fill: "#0FA958"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSuccess);
export default __webpack_public_path__ + "static/media/dataSuccess.a02a80fdbeb054f5074e1a3f16b5981e.svg";
export { ForwardRef as ReactComponent };